import React from 'react';
import notePencilIcon from '../../assets/icons/note-pencil.svg';
import trashIcon from '../../assets/trash.svg';
import { useI18n } from '../../i18n';
import './NoticeboardSection.css';

const NoticeCard = ({ notice, isOwner, onEdit, onDelete }) => {
    const { t } = useI18n();
    return (
        <div className="notice-card-new">
            <div className="notice-author-new">
                {notice.creator?.avatar_url ? (
                    <img src={notice.creator.avatar_url} alt={notice.creator.name} className="author-avatar-new" />
                ) : (
                    <div className="author-avatar-new" style={{ background: '#0C5097', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '24px' }}>
                        {notice.creator?.name?.charAt(0) || 'U'}
                    </div>
                )}
            </div>

            <div className="notice-content-new">
                <h3 className="notice-title-new" title={notice.title}>{notice.title}</h3>
                <p className="notice-description-new">
                    {notice.description}
                </p>
                <div className="notice-card-footer-new">
                    <div className="notice-timestamp-new">
                        {new Date(notice.date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric'
                        })} {notice.time}
                    </div>
                    {isOwner && (
                        <div className="notice-actions-new">
                            <button
                                className="notice-icon-btn"
                                aria-label={t('common.actions.edit')}
                                onClick={(e) => { e.stopPropagation(); onEdit?.(notice); }}
                            >
                                <img src={notePencilIcon} alt="Edit" width={18} height={18} />
                            </button>
                            <button
                                className="notice-icon-btn notice-icon-btn-danger"
                                aria-label={t('common.actions.delete')}
                                onClick={(e) => { e.stopPropagation(); onDelete?.(notice); }}
                            >
                                <img src={trashIcon} alt="Delete" width={18} height={18} />
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NoticeCard;
